import { Coffee } from "lucide-react";

export default function LunchNote({ className = "", testid = "lunch-note" }) {
  return (
    <div className={`inline-flex items-start gap-1.5 text-[11px] text-zinc-400 ${className}`} data-testid={testid}>
      <Coffee className="w-3.5 h-3.5 mt-px shrink-0" />
      <span>Day rate &amp; hours assume one <span className="text-white font-semibold">30-min lunch break</span> is included.</span>
    </div>
  );
}
